import React, { useState } from 'react';

const DOW = ['LUN', 'MAR', 'MER', 'JEU', 'VEN', 'SAM', 'DIM'];
const MONTH_NAMES = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

function CalendarView({ tasks, onOpenTask }) {
  // On ouvre sur le mois courant : c'est là que se trouve le travail du jour.
  const initial = new Date();
  const [viewDate, setViewDate] = useState(new Date(initial.getFullYear(), initial.getMonth(), 1));

  const year = viewDate.getFullYear();
  const month = viewDate.getMonth();

  const firstDay = new Date(year, month, 1);
  const startOffset = (firstDay.getDay() + 6) % 7; // Monday = 0
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const cells = [];
  for (let i = 0; i < startOffset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const tasksByDay = {};
  tasks.forEach((t) => {
    if (!t.due_date) return;
    const d = new Date(t.due_date);
    if (d.getFullYear() === year && d.getMonth() === month) {
      const day = d.getDate();
      if (!tasksByDay[day]) tasksByDay[day] = [];
      tasksByDay[day].push(t);
    }
  });

  const changeMonth = (delta) => setViewDate(new Date(year, month + delta, 1));

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ margin: 0 }}>{MONTH_NAMES[month]} {year}</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="icon-btn" onClick={() => changeMonth(-1)} aria-label="Mois précédent">←</button>
          <button className="btn btn-sm" onClick={() => setViewDate(new Date(initial.getFullYear(), initial.getMonth(), 1))}>Aujourd'hui</button>
          <button className="icon-btn" onClick={() => changeMonth(1)} aria-label="Mois suivant">→</button>
        </div>
      </div>

      <div className="calendar-grid">
        {DOW.map((d) => (
          <div key={d} className="calendar-dow">{d}</div>
        ))}
        {cells.map((day, i) => (
          <div key={i} className={`calendar-cell ${day == null ? 'empty' : ''}`}>
            {day != null && (
              <>
                <div className="calendar-date">{day}</div>
                {/* Les jalons passent en premier et se distinguent par un
                    losange : ce sont les repères de date du projet. */}
                {[...(tasksByDay[day] || [])]
                  .sort((a, b) => (b.est_jalon ? 1 : 0) - (a.est_jalon ? 1 : 0))
                  .slice(0, 5)
                  .map((t) => (
                    <div
                      key={t.id}
                      className={`calendar-task-chip ${t.est_jalon ? 'calendar-jalon-chip' : ''} ${t.status === 'Done' ? 'termine' : ''}`}
                      title={t.est_jalon ? `Jalon : ${t.name}` : t.name}
                      onClick={() => onOpenTask(t)}
                      style={{ cursor: 'pointer' }}
                    >
                      {t.est_jalon ? '◆ ' : ''}{t.name}
                    </div>
                  ))}
                {(tasksByDay[day] || []).length > 5 && (
                  <div className="cal-plus" title="Passez en vue Liste pour tout voir">
                    +{(tasksByDay[day] || []).length - 5} autres
                  </div>
                )}
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default CalendarView;
